import React from 'react';

export function EmptyState(): JSX.Element {
  return (
    <div className="flex justify-center items-center min-h-[200px] text-gray-500">
      No sprints available
    </div>
  );
}
